import { Component, OnInit, EventEmitter, OnDestroy, ViewChild } from '@angular/core';
import { Platform, IonContent, IonRefresher } from '@ionic/angular';
import { IssueSupplier, IssuesOrderSupplier, IssueOrderSupplierType, IssuesFilterSupplier, QuproList } from '@arpada/arp-lib-common-qupro';
import { Subscription } from 'rxjs';


import { PortalProveedorService, IssuePopulateService, MessagesService, GeneralPopulateService } from '../../services/api.services';
import { Constants, IssueFront, Page, DatatableMessage, IIssueFrontSelection } from '../../models/api.models';

import { ActionsSharedData } from '../shared/actions-header/actions.shared.data';
import { IssueReviewPresaleData } from './issue.review.presale.data';

@Component({
  selector: 'app-issues-repasos-preventa',
  templateUrl: './issues-repasos-preventa.component.html',
  styleUrls: ['./issues-repasos-preventa.component.scss'],
})
export class IssuesRepasosPreventaComponent implements OnInit, OnDestroy {

  private readonly ISSUE_CHANGE_EVENT: EventEmitter<number> = new EventEmitter();

  @ViewChild('issuesIonContent' , { static: true }) ionContent: IonContent;
  @ViewChild('issuesRefresher', { static: true }) issuesRefresher: IonRefresher;

  issues: IssueSupplier[];
  issuesToEdit: IssueSupplier[] = [];

  showListButton =  false;
  showCardListButton = true;
  showList = true;
  showCardList = false;
  showEditOperarioButton = true;
  comeFromIssue = true;
  issuesSelected = false;

  filtroIssue = true;
  sharedData: ActionsSharedData = new ActionsSharedData();
  issuesFilter: IssuesFilterSupplier = new IssuesFilterSupplier();
  issuesOrder: IssuesOrderSupplier = new IssuesOrderSupplier(IssueOrderSupplierType.DEFAULT_ORDER);
  loadingIssues = true;
  mode = 'portal-repasos-proveedor';

  totalCount = '-';
  totalCountNumber = -1;
  idsSelected = -1;

  private operatorSelectSubscription: Subscription;
  private operatorUpdatedSubscription: Subscription;
  private selectOperatorSubscription: Subscription;
  private selectionCardSubscription: Subscription;

  idsFilterIssues: number[] = [];

  issueReviewPresaleData: IssueReviewPresaleData = new IssueReviewPresaleData();
  offsetInfiniteScroll: number;
  allCardsSelected = false;
  allCardsSelectButton = true;
  showSelectAllCards: boolean;

  constructor(private portalProveedorService: PortalProveedorService,
              private issuePopulateService: IssuePopulateService,
              private platform: Platform,
              private messages: MessagesService,
              private generalPopulateService: GeneralPopulateService) {
    this.initFilter();
    this.initIssueReviewPresaleData();
    this.initPage();
    this.setHeight(this.platform.height());
  }

  ngOnDestroy(): void {
    if (this.operatorSelectSubscription) {
      this.operatorSelectSubscription.unsubscribe();
    }
    if (this.operatorUpdatedSubscription) {
      this.operatorUpdatedSubscription.unsubscribe();
    }
    if (this.selectOperatorSubscription) {
      this.selectOperatorSubscription.unsubscribe();
    }
    if (this.selectionCardSubscription) {
      this.selectionCardSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    const modoVista = localStorage.getItem('modoVista');
    this.showModoVista(modoVista);
    this.offsetInfiniteScroll = this.issueReviewPresaleData.page.offset;
    this.setTotalCount(-1);
    this.setIdsSelectedNumber(-1);
    this.issueReviewPresaleData.issuesFront = [];
    this.issueReviewPresaleData.idsFilterIssues = [];
    this.messages.onInitTranslateService().subscribe( () => {
      this.getIssues(this.issueReviewPresaleData.page);
    });

    const operatorIdSelected = this.portalProveedorService.getOperatorSel();
    this.selectOperator(operatorIdSelected);
    this.operatorSelectSubscription = this.portalProveedorService.onChangeOperatorSelected(this.selectOperator);
    this.operatorUpdatedSubscription = this.portalProveedorService.updateOperatorEvent.subscribe((issuesUpdated: IssueFront[]) => {
      this.onUpdateOperatorEvent(issuesUpdated);
    });
    this.selectOperatorSubscription = this.portalProveedorService.selectOperatorEvent.subscribe(operatorId => {
      this.issuesFilter.operator_num = operatorId;
      this.getIssues(this.issueReviewPresaleData.page);
    });
    this.selectionCardSubscription = this.portalProveedorService.selectionCardEvent
                                      .subscribe((issueFrontSelection: IIssueFrontSelection) => {
      this.issueReviewPresaleData.issuesFront.forEach((issueFront: IssueFront) => {
        if (issueFrontSelection.selection) {
          if (issueFront.id === issueFrontSelection.id) {
            this.sharedData.issuesFrontIdsSelected.push(issueFrontSelection.id);
          }
        } else {
          this.sharedData.issuesFrontIdsSelected = this.removeItemFromArray(this.sharedData.issuesFrontIdsSelected, issueFrontSelection.id);
        }
      });
      if (this.sharedData.issuesFrontIdsSelected.length === 0) {
        this.idsFilterIssues = [];
        this.setIdsSelectedNumber(-1);
      }
    });
  }

  doInfinite(event) {
    // crearme nueva pagina multplo 4 por tema de MD
    const cardPage: Page = new Page();
    cardPage.offset = 0;
    cardPage.limit = 10;
    cardPage.count = 0;
    ++this.offsetInfiniteScroll;
    cardPage.offset = this.offsetInfiniteScroll;
    this.getIssues(cardPage, event, true);
  }

  onUpdateOperatorEvent(updateIssues: IssueFront[]) {
    this.issueReviewPresaleData.issuesFront.forEach(issueFront => {
      updateIssues.forEach(updateIssue => {
        if (issueFront.id === updateIssue.id) {
          Object.assign(issueFront, updateIssue);
        }
      });
    });
  }

  onListPressed(event: Event) {
    // para volver a ocultar el boton asignar operario
    this.issuesToEdit = [];
    this.showEditOperarioButton = false;
    this.showListButton = false;
    this.showCardListButton = true;
    this.showList = true;
    this.showCardList = false;
    this.showSelectAllCards = false;

  }

  onCardListPressed(event: Event) {
    // para volver a ocultar el boton asignar operario
    this.issuesToEdit = [];
    this.showEditOperarioButton = false;
    this.showListButton = true;
    this.showCardListButton = false;
    this.showList = false;
    this.showCardList = true;
    this.showSelectAllCards = true;
    this.sharedData.issuesFrontIdsSelected = [];
  }

  onGetIssues(envio) {
    this.getIssues(envio.page);
    this.setTotalCount(envio.total);
  }

  onRowSelected(event: IssueFront[]) {
    this.idsFilterIssues = [];
    this.issueReviewPresaleData.idsFilterIssues = [];
    this.issuesSelected = false;
    if (event.length > 0) {
      this.showEditOperarioButton = true;  // de momento no se puede editar operario en este tipo de issues
      this.issuesToEdit = this.issuePopulateService.convertFrontIssuesToIssueSupplier(event, this.issues);
      // para hojas de trabajo: en este caso en vez del filtro se pasa en el filter
      // ids
      this.issuesToEdit.forEach(issue => {
        this.issueReviewPresaleData.idsFilterIssues.push(issue.id);
      });
      this.issuesSelected = true;
      this.setIdsSelectedNumber(this.issueReviewPresaleData.idsFilterIssues.length);
    } else {
      this.showEditOperarioButton = false;
      this.issuesSelected = false;
      this.setIdsSelectedNumber(-1);
    }
  }

  onFilterChange(filtroRecibido) {
    this.showEditOperarioButton = false;
    this.issuesToEdit = [];
    this.idsFilterIssues = [];
    this.issueReviewPresaleData.idsFilterIssues = [];
    this.issueReviewPresaleData.selected = [];
    this.setTotalCount(-1);
    const filterTemp = new IssuesFilterSupplier();
    Object.assign(filterTemp, filtroRecibido);
    this.issuesFilter = filterTemp;
    this.issuesSelected = false;
    this.setIdsSelectedNumber(-1);
    this.initIssueReviewPresaleData();
    this.initPage();
    this.getIssues(this.issueReviewPresaleData.page);
  }

  onOrderChange() {
    /* this.loadingIssues = true;
    this.loadIssues().subscribe(() => {
      this.ionContent.scrollToTop();
      this.loadingIssues = false;
    }, () => {
      this.loadingIssues = false;
    }); */
  }

  onSelectAllPressed(selectAllPressed: Event) {
    this.sharedData.issuesFrontIdsSelected = [];
    this.setIdsSelectedNumber(-1);
    const page: Page = new Page();
    page.limit = 0;
    page.offset = 0;
    if (selectAllPressed) {
      this.allCardsSelectButton = false;
      this.getIssues(page, null, null, true, true);
    } else {
      this.allCardsSelectButton = true;
      this.allCardsSelected = false;
      this.idsFilterIssues = [];
      this.setIdsSelectedNumber(-1);
      this.getIssues(page, null, null, true, false);
    }

  }

  private getIssues(page: Page, event?, doAppend?: boolean, comeFromAllSelected?: boolean, selectAll?: boolean) {
    const start = page.offset * page.limit;
    const limit = page.limit;
    if (!doAppend) {
      this.issueReviewPresaleData.issuesFront = [];
      this.sharedData.issuesFrontIdsSelected = [];
      this.setIdsSelectedNumber(-1);
    }
    this.issueReviewPresaleData.idsFilterIssues = [];
    this.issueReviewPresaleData.msg.emptyMessage = this.generalPopulateService.changeMms(true);
    this.issueReviewPresaleData.loading = true;
    this.portalProveedorService.getReviewPresaleIssuesFromSupplier(this.issuesFilter, this.issuesOrder, start, limit)
    .subscribe((resp: QuproList<IssueSupplier>) => {
      this.setTotalCount(resp.count);
      this.issues = resp.elements;
      this.issueReviewPresaleData.page.count = resp.count;
      if (!doAppend) {
        this.issueReviewPresaleData.issuesFront = this.issuePopulateService.convertirIssuesToReviewPresaleFront(this.issues);

      } else {
        if (this.issues != null && this.issues.length > 0) {
          this.issues.forEach((issue: IssueSupplier) => {
            this.issueReviewPresaleData.issuesFront.push(this.issuePopulateService.convertirIssueToReviewPresaleFront(issue));
          });
        }
      }
      this.issueReviewPresaleData.idsFilterIssues = this.idsFilterIssues;
      this.issueReviewPresaleData.loading = false;
      this.issueReviewPresaleData.msg.emptyMessage = this.generalPopulateService.changeMms(false);
      if (event) {
        event.target.complete();
      }
      if (comeFromAllSelected) {
        this.sharedData.issuesFrontIdsSelected = [];
        this.allCardsSelected = selectAll;
        if (!selectAll) {
          this.setIdsSelectedNumber(-1);
          this.portalProveedorService.selectionAllCardsEvent.emit(selectAll);
        } else {
          this.setIdsSelectedNumber(this.issueReviewPresaleData.issuesFront.length);
          this.portalProveedorService.selectionAllCardsEvent.emit(selectAll);
        }
      }
    });
  }

  private showModoVista(modoVista: string) {
    if (modoVista === 'cards') {
      this.onCardListPressed(null);
      this.showSelectAllCards = true;
    }
    if (modoVista === 'escritorio') {
      this.onListPressed(null);
      this.showSelectAllCards = false;
    }
  }

  private selectOperator = (id: number) => {
    if (id > 0) {
      this.issuesFilter.operator_num = id;
    }
  }

  private setHeight(height: number) {
    if (height <= 650) {
      this.issueReviewPresaleData.page.limit = 6;
    }
    if (height > 650 && height <= 736) {
      this.issueReviewPresaleData.page.limit = 7;
    }
    if (height > 736 &&  height <= 823) {
      this.issueReviewPresaleData.page.limit = 9;
    }
    if (height > 850) {
      this.issueReviewPresaleData.page.limit = 10;
    }
  }

  private initPage() {
    this.issueReviewPresaleData.page.offset = 0;
    this.issueReviewPresaleData.page.limit = 10;
    this.issueReviewPresaleData.page.count = 0;
  }

  private initIssueReviewPresaleData() {
    this.issueReviewPresaleData.issuesFront = [];
    this.issueReviewPresaleData.selected = [];
    this.issueReviewPresaleData.page = new Page();
    this.issueReviewPresaleData.idsFilterIssues =  [];
    this.issueReviewPresaleData.loading = true;
    this.issueReviewPresaleData.msg = new DatatableMessage();
    this.issueReviewPresaleData.msg.emptyMessage = '';
    this.issueReviewPresaleData.msg.totalMessage = 'total';
  }

  private initFilter(csiteId?: number) {
    const newFilter: IssuesFilterSupplier = new IssuesFilterSupplier();
    newFilter.setPhaseKeys(Constants.SUPPLIER_PRESALE_REVIEW_PHASES_FILTER);
    newFilter.setStateGroupKeys(Constants.SUPPLIER_PRESALE_REVIEW_STATES_GROUPS_INIT_FILTER);
    const operatorIdSelected = this.portalProveedorService.getOperatorSel();
    if (operatorIdSelected) {
      newFilter.operator_num = operatorIdSelected;
    }
    // Assign all fields to actual filter
    Object.assign(this.issuesFilter, newFilter);
  }

  private setTotalCount(totalCountNumber: number) {
    this.totalCountNumber = totalCountNumber;
    if (totalCountNumber >= 0) {
      this.totalCount = totalCountNumber + '';
      this.sharedData.totalCount = totalCountNumber + '';
    } else {
      this.totalCount = '-';
      this.sharedData.totalCount = '-';
    }
  }

  private setIdsSelectedNumber(idsSelected: number) {
    this.idsSelected = idsSelected;
    if (idsSelected >= 0) {
      this.sharedData.idsSelected = idsSelected + '';
    } else {
      this.sharedData.idsSelected = '-';
    }
  }

  private removeItemFromArray(arr: number[], item: number): number[] {
    return arr.filter((e) => {
      return e !== item;
    });
  }
}
